module.exports = __webpack_public_path__ + "img/black.b09765b6.png";